export const getHtml = (nodo) => {
    var htmlResult = "";
    if (nodo.Type == "Texto") {
        htmlResult += nodo.Value;
    }
    if (nodo.Type == "Html") {
        htmlResult += "<" + nodo.HtmlTag + ">";
    }
    if (nodo.Nodes != null) {
        for (var i = 0; i < nodo.Nodes.length; i++) {
            htmlResult += getHtml(nodo.Nodes[i]);
        }
    }
    if (nodo.Type == "Html") {
        htmlResult += "</" + nodo.HtmlTag + ">";
    }
    return htmlResult;
}


// WEBPACK FOOTER //
// ./Statics/scripts/common/inodo.js